import React from "react";
import {Gauge} from "@mui/x-charts-pro";
import CCMuiValueChart from "./CCMuiValueChart";

class CCGauge extends CCMuiValueChart {
    static ATTR_MAP: [string, string][] = [
        ["CornerRadius", "cornerRadius"],
        ["EndAngle", "endAngle"],
        ["Height", "height"],
        ["Id", "id"],
        ["InnerRadius", "innerRadius"],
        ["Margin", "margin"],
        ["OuterRadius", "outerRadius"],
        ["StartAngle", "startAngle"],
        ["Text", "text"],
        ["ValueMax", "valueMax"],
        ["ValueMin", "valueMin"],
        ["Width", "width"],
    ];

    constructor(props: any) {
        super(props);

        this.state.Value = props.value;
    }

    renderChart(chartProps: any): React.ReactNode {
        return <Gauge {...chartProps} value={this.state.Value} sx={this.props.sx} />;
    }
}

export default CCGauge;
